import { getWithAuth, postWithAuth } from 'lib/api'
import React, { useEffect, useRef, useState } from 'react'
import InstaStories from 'react-insta-stories'
import { useParams } from 'react-router-dom'

const getUserName = (name: string) => {
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
}

type Story = {
  url: string
  type: 'image' | 'video'
  user: string
}
type StoriesType = Record<
  string,
  {
    stories: Story[]
    user: string
  }
>

const Stories: React.FC<{ event: any }> = (props) => {
  const storyInputRef = useRef<HTMLInputElement>(null)

  const [stories, setStories] = useState<StoriesType>({})
  const [showStories, setShowStories] = useState(-1)

  const [isUploading, setIsUploading] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)

  const { code } = useParams()

  const fetchStories = async () => {
    const response = await getWithAuth(`/story/${code}`)
    setStories(response.stories)
  }

  const onStoryUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]

    if (file && props.event?.uuid) {
      setIsUploading(true)

      const formData = new FormData()

      formData.append('file', file)

      let type = 'image'
      if (file.type.includes('video')) {
        type = 'video'
      }

      formData.append('type', type)

      try {
        await postWithAuth(`/story/${code}`, formData)

        setIsUploading(false)
        setIsSuccess(true)
        fetchStories()
        storyInputRef.current!.value = ''
      } catch (e) {
        console.log(e)
      }
    }
  }

  useEffect(() => {
    if (!code) {
      return
    }

    fetchStories()
  }, [code])

  return (
    <div>
      {isUploading && (
        <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[calc(100%-80px)] bg-[#0B0B0B] rounded-[16px] flex flex-col items-center justify-center pt-[34px] pb-[24px] z-50">
          <div className="mb-[16px]">
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M38.8708 1.16397C37.8703 0.137196 36.3897 -0.245326 35.0092 0.157329L2.81599 9.51905C1.3594 9.92372 0.326974 11.0854 0.0488603 12.5611C-0.235256 14.063 0.75715 15.9696 2.05368 16.7668L12.1198 22.9536C13.1522 23.5878 14.4848 23.4288 15.3391 22.5671L26.8658 10.9686C27.4461 10.3646 28.4065 10.3646 28.9867 10.9686C29.5669 11.5525 29.5669 12.4987 28.9867 13.1027L17.44 24.7032C16.5836 25.5628 16.4236 26.9016 17.0538 27.9405L23.2043 38.1075C23.9246 39.3155 25.1651 40 26.5257 40C26.6858 40 26.8658 40 27.0259 39.9799C28.5865 39.7785 29.8271 38.7115 30.2872 37.2015L39.8311 5.04958C40.2513 3.68056 39.8712 2.19073 38.8708 1.16397Z"
                fill="white"
              />
            </svg>
          </div>
          <div className="text-[18px] leading-[28px] text-white font-bold mb-[15px]">
            Yükleniyor...
          </div>
          <div className="text-[14px] leading-[16px] text-[#989898] mb-[36px] text-center">
            Bu işlem yüklediğiniz medya boyutuna göre biraz zaman alabilir.
          </div>
        </div>
      )}
      {isSuccess && (
        <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[calc(100%-80px)] bg-[#0B0B0B] rounded-[16px] flex flex-col items-center justify-center pt-[18px] pb-[24px] z-50">
          <div className="mb-[6px]">
            <svg
              width="94"
              height="94"
              viewBox="0 0 94 94"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M44.4286 1.542C46.0115 0.592791 47.9885 0.592792 49.5714 1.542L58.7949 7.07302C59.4438 7.46213 60.1725 7.69891 60.9262 7.76551L71.6392 8.71226C73.4777 8.87473 75.0772 10.0368 75.7999 11.7352L80.0108 21.6313C80.307 22.3275 80.7574 22.9474 81.328 23.4442L89.4385 30.5071C90.8304 31.7192 91.4414 33.5995 91.0277 35.3983L88.6176 45.8795C88.4481 46.6169 88.4481 47.3831 88.6176 48.1205L91.0277 58.6017C91.4414 60.4005 90.8304 62.2808 89.4385 63.4929L81.328 70.5558C80.7574 71.0526 80.307 71.6725 80.0108 72.3687L75.7999 82.2649C75.0772 83.9632 73.4777 85.1253 71.6392 85.2877L60.9262 86.2345C60.1725 86.3011 59.4438 86.5379 58.7949 86.927L49.5714 92.458C47.9885 93.4072 46.0115 93.4072 44.4286 92.458L35.2051 86.927C34.5562 86.5379 33.8275 86.3011 33.0738 86.2345L22.3608 85.2877C20.5223 85.1253 18.9228 83.9632 18.2001 82.2649L13.9892 72.3687C13.693 71.6725 13.2426 71.0526 12.672 70.5558L4.56148 63.4929C3.1696 62.2808 2.55865 60.4005 2.97226 58.6017L5.38235 48.1205C5.5519 47.3831 5.5519 46.6169 5.38235 45.8795L2.97226 35.3983C2.55865 33.5995 3.1696 31.7192 4.56149 30.5071L12.672 23.4442C13.2426 22.9474 13.693 22.3275 13.9892 21.6313L18.2001 11.7351C18.9228 10.0368 20.5223 8.87473 22.3608 8.71226L33.0738 7.76551C33.8275 7.69891 34.5562 7.46213 35.2051 7.07302L44.4286 1.542Z"
                fill="#1E1E1E"
              />
              <circle cx="47" cy="47" r="23" fill="white" />
              <path
                d="M42.38 52.94L35.285 45.845C34.68 45.24 33.91 44.9375 32.975 44.9375C32.04 44.9375 31.27 45.24 30.665 45.845C30.06 46.45 29.7575 47.22 29.7575 48.155C29.7575 49.09 30.06 49.86 30.665 50.465L40.07 59.87C40.73 60.53 41.5 60.86 42.38 60.86C43.26 60.86 44.03 60.53 44.69 59.87L63.335 41.225C63.94 40.62 64.2425 39.85 64.2425 38.915C64.2425 37.98 63.94 37.21 63.335 36.605C62.73 36 61.96 35.6975 61.025 35.6975C60.09 35.6975 59.32 36 58.715 36.605L42.38 52.94ZM47 80C42.435 80 38.145 79.1332 34.13 77.3996C30.115 75.666 26.6225 73.3153 23.6525 70.3475C20.6825 67.3775 18.3318 63.885 16.6004 59.87C14.869 55.855 14.0022 51.565 14 47C14 42.435 14.8668 38.145 16.6004 34.13C18.334 30.115 20.6847 26.6225 23.6525 23.6525C26.6225 20.6825 30.115 18.3318 34.13 16.6004C38.145 14.869 42.435 14.0022 47 14C51.565 14 55.855 14.8668 59.87 16.6004C63.885 18.334 67.3775 20.6847 70.3475 23.6525C73.3175 26.6225 75.6693 30.115 77.4029 34.13C79.1365 38.145 80.0022 42.435 80 47C80 51.565 79.1332 55.855 77.3996 59.87C75.666 63.885 73.3153 67.3775 70.3475 70.3475C67.3775 73.3175 63.885 75.6693 59.87 77.4029C55.855 79.1365 51.565 80.0022 47 80Z"
                fill="#55B755"
              />
            </svg>
          </div>
          <div className="text-[18px] leading-[28px] text-white font-bold mb-[15px]">
            Başarılı
          </div>
          <div className="text-[14px] leading-[16px] text-[#989898] mb-[36px]">
            Story paylaşımı başarıyla tamamlandı.
          </div>
          <div>
            <div
              className="w-full bg-[#fff] text-[14px] leading-[22px] text-[#030303] font-bold rounded-[100px] px-[54px] py-[10px]"
              onClick={() => setIsSuccess(false)}
            >
              Devam
            </div>
          </div>
        </div>
      )}
      <input
        ref={storyInputRef}
        type="file"
        className="hidden"
        accept="image/*,video/*"
        onChange={onStoryUpload}
      />

      <div className="flex overflow-x-auto scrollbar-hide px-[16px] mb-[16px] gap-2.5">
        {stories !== null &&
          Object.values(stories).map((story, index) => (
            <div
              key={story.user}
              className="flex flex-col gap-2.5 items-center w-[100px] text-center"
              onClick={() => setShowStories(index)}
            >
              <div className="w-[100px] h-[140px] bg-[rgba(255,255,255,0.1)] rounded-[16px] flex items-end justify-center pb-2">
                <div className="w-[40px] h-[40px] rounded-full bg-[#272828] flex items-center justify-center text-[14px] font-medium text-white mx-[4px] shrink-0">
                  {getUserName(story.user)}
                </div>
              </div>
              <div className="text-[12px]">{story.user}</div>
            </div>
          ))}
      </div>

      <div
        className="flex flex-col gap-2.5 items-center mt-[30px]"
        onClick={() => storyInputRef.current?.click()}
      >
        <div className="flex items-center justify-center gap-2.5 w-[60px] h-[60px] rounded-full border-[2px] border-[#D6FF00]">
          <svg
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M24.7573 10.7595L17.2361 10.7595L17.2361 3.24266C17.2361 1.45375 15.7867 -5.68388e-10 13.9978 -5.0398e-10C12.2089 -4.39572e-10 10.7552 1.45375 10.7552 3.24266L10.7552 10.7595L3.2383 10.7595C1.4494 10.7595 4.39729e-10 12.2133 5.04137e-10 14.0022C5.68545e-10 15.7911 1.4494 17.2448 3.2383 17.2448L10.7552 17.2448L10.7552 24.7573C10.7552 26.5462 12.2089 28 13.9978 28C15.7867 28 17.2361 26.5462 17.2361 24.7573L17.2361 17.2448L24.7573 17.2448C26.5462 17.2448 28 15.7911 28 14.0022C28 12.2133 26.5462 10.7595 24.7573 10.7595Z"
              fill="#D6FF00"
            />
          </svg>
        </div>
        <div className="text-[#EEEEEEEE]">Story Paylaş</div>
      </div>
      {showStories !== -1 && (
        <div className="fixed top-0 left-0 w-full h-full bg-[#030303] z-50">
          <div
            className="absolute top-0 left-0 w-full h-[80px] z-50"
            style={{
              background:
                'linear-gradient(0deg, rgba(3, 3, 3, 0.00) 20.73%, #030303 100%)',
            }}
          />
          <div
            className="absolute top-0 right-0 p-[16px] z-[1000000]"
            onClick={() => setShowStories(-1)}
          >
            <svg
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.9927 19.4933C16.2642 19.4933 19.7899 15.9676 19.7899 11.7037C19.7899 7.43973 16.2567 3.91406 11.9852 3.91406C7.72126 3.91406 4.20312 7.43973 4.20312 11.7037C4.20312 15.9676 7.72879 19.4933 11.9927 19.4933ZM11.9927 17.9414C8.53488 17.9414 5.77009 15.1616 5.77009 11.7037C5.77009 8.24581 8.53488 5.47349 11.9852 5.47349C15.4431 5.47349 18.2229 8.24581 18.2305 11.7037C18.238 15.1616 15.4506 17.9414 11.9927 17.9414ZM9.52176 14.8677C9.71763 14.8677 9.8909 14.7999 10.019 14.6643L11.9927 12.6906L13.9665 14.6643C14.0946 14.7924 14.2603 14.8677 14.4637 14.8677C14.8479 14.8677 15.1493 14.5664 15.1493 14.1822C15.1493 13.9939 15.0739 13.8281 14.9459 13.7001L12.9646 11.7188L14.9459 9.72991C15.089 9.58677 15.1568 9.4361 15.1568 9.2553C15.1568 8.87109 14.8555 8.56975 14.4713 8.56975C14.2829 8.56975 14.1247 8.63002 13.9816 8.77316L11.9927 10.7545L10.0039 8.78069C9.87584 8.64509 9.71763 8.57729 9.52176 8.57729C9.13756 8.57729 8.83622 8.87109 8.83622 9.2553C8.83622 9.44364 8.91155 9.60938 9.04715 9.73744L11.0209 11.7188L9.04715 13.7076C8.91155 13.8281 8.83622 14.0014 8.83622 14.1822C8.83622 14.5664 9.13756 14.8677 9.52176 14.8677Z"
                fill="#fff"
              />
            </svg>
          </div>
          <div className="text-[14px] leading-[1.6] font-medium text-white text-center absolute top-[20px] left-[16px] z-[1000000]">
            {Object.values(stories || {})?.[showStories]?.user}
          </div>
          <InstaStories
            stories={Object.values(stories || {})?.[showStories]?.stories || []}
            defaultInterval={3000}
            width={window.innerWidth}
            height={window.innerHeight}
            onAllStoriesEnd={() => setShowStories(-1)}
          />
        </div>
      )}
    </div>
  )
}

export default Stories
